import { render, staticRenderFns } from "./AlipayMerchant.vue?vue&type=template&id=282a40c2&scoped=true&"
import script from "./AlipayMerchant.vue?vue&type=script&lang=js&"
export * from "./AlipayMerchant.vue?vue&type=script&lang=js&"
import style0 from "./AlipayMerchant.vue?vue&type=style&index=0&id=282a40c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282a40c2",
  null
  
)

export default component.exports